import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { BaseUrlConstantsService } from "../../../app/services/base-url-constants.service";
import { PowerTrainService } from "../../../app/services/powertrain.service";
import { MachineUtilization } from "../powertrain-modal/powertrain.model";
import { CommonModule } from "@angular/common";
import { PowertrainModalComponent } from "../powertrain-modal/powertrain-modal.component";
import { MatTooltip, MatTooltipModule } from "@angular/material/tooltip";
import { NgbPopover, NgbPopoverModule } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-powertrain-operational-kpi",
  templateUrl: "./powertrain-operational-kpi.component.html",
  styleUrls: ["./powertrain-operational-kpi.component.scss"],
  standalone: true,
  imports: [CommonModule,PowertrainModalComponent,MatTooltip,MatTooltipModule,NgbPopover,NgbPopoverModule],
  encapsulation: ViewEncapsulation.None
})
export class PowertrainOperationalKpiComponent implements OnInit {
  @Input("mac_address") mac_address: string;
  @Input('client_id') client_id!: number| string;
  machine_utilization_url =
    BaseUrlConstantsService.POWERTRAIN_MACHINE_UTILIZATION_API;
  machine_utilization: MachineUtilization = {
    no_of_starts: "N/A",
    no_of_stops: "N/A",
    total_tm: "N/A",
    deviceOFFLINETime: "N/A",
    DEVICE_ONLINE_TIME: "N/A",
    device_utilization: "N/A",
    avg_run: "N/A",
  };
  machine_utilization_status_loader: boolean = true;

  constructor(private service: PowerTrainService) {}

  ngOnInit(): void {
    this.fetchMachineUtilization();
  }

  fetchMachineUtilization() {
    this.machine_utilization_status_loader = true;
    this.service
      .fetchPowertrainUtilization(
        `${this.machine_utilization_url}${this.mac_address}/${this.client_id}/1`
      )
      .then((machineUtilRes: MachineUtilization) => {
        this.machine_utilization = machineUtilRes;
        this.machine_utilization_status_loader = false;
      })
      .catch((err) => {
        console.error(err);
        this.machine_utilization_status_loader = false;
      });
  }
}
